module.exports = __webpack_public_path__ + "static/media/09_NFP66A.203c7549.png";